<template>
  <main-container :title="'お問合せ詳細'" :subTitle="supportId" class="support-edit-container">
    <div slot="main-content">
      <form-container class="support-overview-container">
        <form-item-container label="カテゴリー">{{supportDetail.categoryName}}</form-item-container>
        <form-item-container label="件名">{{supportDetail.subject}}</form-item-container>
        <form-item-container label="ステータス">{{getStatusName(supportDetail.status)}}</form-item-container>
        <form-item-container label="作成日時">{{supportDetail.createdAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DDHH:mm')}}
        </form-item-container>
      </form-container>

      <form-container class="support-communications-container">
        <form-item-container v-for="communication in supportDetail.communications">
          <template slot="form-item-label">
            <div class="communication-user">{{getUserName(communication)}}</div>
            <div class="communication-date">{{communication.createdAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DDHH:mm')}}
            </div>
          </template>
          <span class="communication-body">
            <div v-html="getEscapedBody(communication.body)"></div>
            <div class="communication-attachment-container">
              <div v-for="attachment in communication.attachments">
                <span class="link" @click="downloadAttachment(communication, attachment)"><font-awesome-icon
                        class="icon" icon="paperclip" style="margin-right: 6px;"/>{{attachment.orgFileName}}</span>
              </div>
            </div>
          </span>
        </form-item-container>
      </form-container>

      <support-create v-if="visibleSupportCreate" :supportId="supportId" :categoryId="supportDetail.categoryId"
                      :subject="supportDetail.subject" :categoryName="supportDetail.categoryName"
                      @close="visibleSupportCreate=false" @updated="reload"></support-create>
    </div>

    <template slot="main-footer">
      <el-button type="default" @click="onClickCancel"
                 v-if="supportDetail.status === 'WAITING' || supportDetail.status === 'PROCESSING'">キャンセル
      </el-button>
      <el-button type="default" @click="changeLocation('support-list')">戻る</el-button>
      <el-button type="primary" @click="onClickAdd"
                 v-if="supportDetail.status && supportDetail.status !== 'RESOLVED' && supportDetail.status !== 'CANCELED'">
        お問合せを続ける
      </el-button>
      <el-button type="primary" @click="onClickResolve" v-if="supportDetail.status === 'ANSWERED'">お問合せを完了する</el-button>
    </template>
  </main-container>
</template>

<script>
import BaseView from '../base'
import SupportCreateCmp from '../../components/support/dialogs/create.vue'
import { SupportStatus, SupportUserType } from '../../defines/support'
import WebApiClient from '../../api/web'
import MessageBox from '../../utils/message-box'
import FormatUtil from '../../utils/format'

export default {
  name: 'SupportEditView',
  mixins: [BaseView],
  components: {
    'support-create': SupportCreateCmp
  },
  props: {
    supportId: ''
  },
  data () {
    return {
      visibleSupportCreate: false,
      supportDetail: {
        supportId: '',
        categoryId: '',
        categoryName: '',
        subject: '',
        createdAt: '',
        updatedAt: '',
        status: null,
        communications: []
      }
    }
  },
  created () {
    WebApiClient.getSupportCommunications(this, this.supportId).then(response => {
      this.supportDetail = response.data.result
    })
  },
  methods: {
    getUserName (communication) {
      return communication.userType === SupportUserType.SUPPORT ? 'SkyFoxサポート' : `${communication.userName}　様`
    },

    getStatusName (status) {
      switch (status) {
          case SupportStatus.WAITING:
            return 'サポート受付待ち'
          case SupportStatus.PROCESSING:
            return 'サポート対応中'
          case SupportStatus.ANSWERED:
            return 'サポート回答済み'
          case SupportStatus.RESOLVED:
            return '解決済み'
          case SupportStatus.CANCELED:
            return 'キャンセル'
          default:
            return ''
      }
    },

    getEscapedBody (body) {
      return FormatUtil.escapeHtml(body, {
        nl2br: true,
        enableLink: true
      })
    },

    onClickAdd () {
      this.visibleSupportCreate = true
    },

    onClickResolve () {
      MessageBox.confirm(this, 'お問合せを完了します。<br>よろしいですか？', {
        dangerouslyUseHTMLString: true
      }).then(() => {
        WebApiClient.putSupport(this, this.supportId, {
          status: SupportStatus.RESOLVED
        }).then(response => {
          this.$set(this.supportDetail, 'status', SupportStatus.RESOLVED)
        })
      }).catch(() => {})
    },

    onClickCancel () {
      MessageBox.confirm(this, 'お問合せをキャンセルします。<br>よろしいですか？', {
        dangerouslyUseHTMLString: true
      }).then(() => {
        WebApiClient.putSupport(this, this.supportId, {
          status: SupportStatus.CANCELED
        }).then(response => {
          this.$set(this.supportDetail, 'status', SupportStatus.CANCELED)
        })
      }).catch(() => {})
    },

    downloadAttachment (communication, attachment) {
      WebApiClient.postSupportAttachmentPreSignedUrl(this, this.supportId, communication.communicationId,
        attachment.attachmentId).then(response => {
        this.$nextTick(() => {
          const linkEl = document.createElement('a')
          linkEl.href = response.data.result.preSignedUrl
          linkEl.click()
        })
      })
    }
  }
}

</script>

<style scoped>
  .support-edit-container >>> .main-content {
    padding: 24px;
    height: 100%;
  }

  .support-overview-container {
    margin-bottom: 24px;
  }

  .support-overview-container .form-item {
    min-height: auto;
  }

  .support-overview-container .form-item > .form-item-body {
    justify-content: center;
  }

  .support-communications-container .communication-date {
    font-size: 0.77rem;
    font-weight: normal;
  }

  .support-communications-container .communication-body {
    word-break: break-all;
  }

  .support-communications-container .communication-body .communication-attachment-container {
    font-size: .8rem;
    margin-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/views/support/detail.vue